import { ChassisType, ChassisModelTypes, ChassisSeriesTypes, ChassisPassengerCapacities } from "../../../../../@types/ChassisType";
import assets from "../../../../../assets";

// X4 Specific Products
import {
    ChassisBatteryConfigs,
    ChassisBatteryConfigsPreassembly
} from "./X4Products/ChassisBatteryConfigs";
import SeatFrames from "./X4Products/SeatFrames";
import Tops from "./X4Products/Tops";

// Shared Products between XSeries Chassis
import { BodyColorsX4 } from "../Shared/BodyColors";
import { LiftKitsX4 } from "../Shared/LiftKit";
import Batteries from "../Shared/Batteries";
import {
    Wheels12InLiftedX4,
    Wheels12InX4,
    Wheels14InLiftedX4,
    Wheels14InX4,
    Wheels15InX4,
    WheelSizeOptions
} from "../Shared/Wheels";
import LugNuts from "../../Shared/LugNuts";
import {
    Tires12In,
    Tires12InLifted,
    Tires14In,
    Tires14InLifted,
    Tires15In,
    Tires15InLifted
} from "../Shared/Tires";
import WindShields from "../Shared/WindShields";
import {
    ColoradoDesignSolidFrontSeatsX4,
    ColoradoDesignSolidRearSeatsX4
} from "../Shared/Seats";
import { AccessoriesXSeries, AccessoriesXSeriesLifted, AccessoriesXSeriesOptional, AccessoriesXSeriesOptionalLifted, AccessoriesXSeriesOptionalNonLifted } from "../../Shared/Accessories";
import { LsvKits_2023 } from "./X4Products/LsvKits";


export const X4: ChassisType = {
    id: `${ChassisModelTypes.X4}-2023`,
    sku: `${ChassisModelTypes.X4}-2023`,
    series: ChassisSeriesTypes.XSeries,
    categoryName: 'XSeries',
    name: `2023 XSeries X4 4 Passenger`,
    year: 2023,
    model: ChassisModelTypes.X4,
    logo: assets.images.chassisLogo.x4,
    passengerCapacity: ChassisPassengerCapacities["4 Passenger"],
    price: 7460.00,
    retailPrice: 12495,
    marketingSlogan:
        `The Official Cart of Good Times™`,
    bodyColorOptions: BodyColorsX4,
    liftKitOptions: LiftKitsX4,
    chassisBatteryConfigOptions: ChassisBatteryConfigs,
    chassisBatteryOptions: Batteries,
    wheelSizeOptions: WheelSizeOptions,
    wheelOptions: [
        ...Wheels12InX4,
        ...Wheels14InX4
    ],
    wheelOptionsLifted: [
        ...Wheels12InLiftedX4,
        ...Wheels14InLiftedX4,
        ...Wheels15InX4
    ],
    lugNutOptions: LugNuts,
    tireOptions: [
        ...Tires12In,
        ...Tires14In,
        ...Tires15In
    ],
    tireOptionsLifted: [
        ...Tires12InLifted,
        ...Tires14InLifted,
        ...Tires15InLifted
    ],
    lsvKitOptions: LsvKits_2023,
    topOptions: Tops,
    windshieldOptions: WindShields,
    frontSeatOptions: ColoradoDesignSolidFrontSeatsX4,
    rearSeatOptions: ColoradoDesignSolidRearSeatsX4,
    seatFrameOptions: SeatFrames,
    preassembled: false,
    allowInternationalPurchase: true,
    includedAccessories: AccessoriesXSeries,
    includedAccessoriesLifted: AccessoriesXSeriesLifted,
    optionalAccessories: [...AccessoriesXSeriesOptional, ...AccessoriesXSeriesOptionalNonLifted],
    optionalAccessoriesLifted: AccessoriesXSeriesOptionalLifted
};

export const X4Assy: ChassisType = {
    ...X4,
    id: `${ChassisModelTypes.X4}-2023-Assy`,
    sku: `${ChassisModelTypes.X4}-2023-Assy`,
    price: 7760,
    preassembled: true,
    allowInternationalPurchase: false,
    lsvKitOptions: LsvKits_2023,
    chassisBatteryConfigOptions: ChassisBatteryConfigsPreassembly
};